//own imports
import '../../appStyles.css'
import './Account.css'
import LoadingGif from '../../../images/LoadingGif.gif';

//imports react
import React, {
    useState,
    useEffect
} from 'react';
import Popup from 'reactjs-popup';
import QRCode from "react-qr-code";

//imports firebase
import { getAuth, signOut, onAuthStateChanged, updatePassword } from "firebase/auth";
import {collection, query, where, getDocs, getFirestore } from "firebase/firestore";
import { FaEye,  } from 'react-icons/fa';

const db = getFirestore();
const auth = getAuth();

const Account = () => {

    const [userName, setUserName] = useState("");
    const [currentUser, setCurrentUser] = useState(null);
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        document.title = 'Account';
        const auth = getAuth();
        getCurrentUser();

        onAuthStateChanged(auth, (user) => {
            if (user !== null) {
                getCurrentUser();
            }
        });
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);// empty dependencies array => useEffect will only be called once.
       
    if (currentUser === null) {
        return (
            <div className="account-container" style={{ minHeight: '100vh' }}>
                <h1 className='header'>Account</h1>
                <img src={LoadingGif} alt="Loading" />
            </div>
        );
    }
        
    else
        return (
            <div style={{ minHeight: '100vh' }}>
                <h1 className="header">Account</h1>
                <p className='errorMessage'></p>
                <div className="qrContainer">
                    <div style={{ color: 'lightslategray', margin: '1rem' }}>Your QR-code</div>
                    <div className="qrCode">
                        <QRCode value={currentUser.uid} />
                    </div>
                </div>
                <div className="accountContainer">
                        <div className="accountBox">
                            <p className="staticText">Username</p>
                            {userName !== "" ?
                                <p className="infoUser uName">{userName ? userName : currentUser.displayName}</p>
                                : <p className="infoUser uName">{currentUser ? currentUser.displayName : "null"}</p>
                            }
                        </div>
                        <div className="accountBox">
                            <p className="staticText">Email</p>
                            <p className="infoUser uEmail">{currentUser ? currentUser.email : "null"}</p>
                        </div>
                        <div className="accountBox">
                            <p className="staticText">Password</p>
                            <p className="infoUser">*********</p>
                        </div>
                    {currentUser.displayName !== null ? <div style={{ color: 'lightslategray', margin: '1rem' }}>Only local accounts can change their password</div> : <div> <p style={{margin:'0.5rem'}} className='pasChangeInfo' ></p> <button style={{width:'100%'}} className="changePasswordLink btn-secondary" onClick={showPasswordFields}>Change password</button></div>}
                    <div className='passwordChangeBox' style={{display:'none', width:'100%'}}>
                        <div className='form'>
                            <p style={{color:'lightslategray'}}>You have to be recently signed in to perform this action.</p>
                            <label className="label" htmlFor="uPass">Password:</label><br />
                            <input onInput={checkifPasswordsMatch} className="inputField" type="password" name="uPass" id="uPass" /><div className='eyeBox' style={{ textAlign:'right', marginTop:'-2.55rem', marginRight:'1rem', zIndex:'100000'}} onClick={togglePassword}><FaEye size={20}></FaEye></div> <br />
                            <label className="label" htmlFor="uPass">Confirm Password:</label><br />
                            <input onInput={checkifPasswordsMatch} className="inputField" type="password" name="uRPass" id="uRPass" />
                            <p className='errorMessage errorMessagePaswword'></p>
                            <Popup 
                                trigger={<button disabled={disabled} style={{ filter: 'grayscale(1)' }} className='btn-primary btnChangePas'  >Change Password</button>} modal>

                                {close => (
                                    <div className='popUpDeleteGroup'>
                                        <div className="popUpDeleteGroup_header"> Update Password </div>
                                        <div className="popUpDeleteGroup_content">Are you sure to update your password?</div>
                                        <div className='actions'>
                                            <button className='btn-secondary' onClick={() => { close(); }} >Cancel</button>
                                            <button className='btn-primary btnChangePas' onClick={() => { changePassword(currentUser, document.getElementById('uPass').value); close();}}>Confirm Change</button>
                                        </div> 
                                     </div>  
                                )}
                            </Popup>
                        </div>
                    </div>
                    <button className='btn-secondary btnCancel' onClick={showPasswordFields} style={{display:'none'}}>Cancel</button>
                    <button className="btnSignOut btn-primary" onClick={signUserOut}>Sign out</button>
                </div>
            </div>
        );

    function togglePassword(){
        const eyeBox = document.querySelector('.eyeBox');
        if(document.getElementById('uPass').type === 'password'){
            document.getElementById('uPass').type = 'text';
            eyeBox.innerHTML = '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 640 512" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"></path></svg>';
        }
        else{
            document.getElementById('uPass').type = 'password';
            eyeBox.innerHTML = '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path><path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path></svg>';
           //eyeBox.appendChild = <FaEye style={{ float: 'right' }}></FaEye>;
        }
    }

    function signUserOut() {
        const auth = getAuth();
        signOut(auth).then(() => {
            console.log("Goodbye");
            window.location.href = "/";
        }).catch((error) => {
            // An error happened.
        });
    }

    function checkifPasswordsMatch() {
        const inputPaswword = document.getElementById('uPass');
        const inputConfirmPassword = document.getElementById('uRPass');
        const signUpBtn = document.getElementsByClassName('btnChangePas')[0];

        const password = inputPaswword.value;
        const confirmPassword = inputConfirmPassword.value;
        const errorMessage = document.getElementsByClassName('errorMessagePaswword')[0];

        if (password === null || password === '') {
            signUpBtn.style.filter = "grayscale(1)";
            setDisabled(true);
            errorMessage.innerHTML = "Please fill in a password.";
            errorMessage.style.color = "red";
            inputConfirmPassword.style.border = '1px solid red';
            inputPaswword.style.border = '1px solid lightslategray';
        }
        else {
            inputPaswword.style.border = '1px solid green';
            if (password === confirmPassword) {
                if (password.length > 5) {
                    inputConfirmPassword.style.border = '1px solid green';
                    errorMessage.innerHTML = "Passwords match.";
                    errorMessage.style.color = 'green';
                    signUpBtn.classList.remove("btnSignUpDisabled");
                    signUpBtn.style.filter = "grayscale(0)";
                setDisabled(false);
                }
                else {
                    errorMessage.style.color = 'red';
                    errorMessage.innerHTML = "Passwords must at least be 6 characters long.";
                }
            }
            else {
                inputConfirmPassword.style.border = '1px solid red';
                signUpBtn.style.filter = "grayscale(1)";
                setDisabled(true);
                errorMessage.innerHTML = "Passwords do not match.";
                errorMessage.style.color = 'red';
            }
        }
    }

    function getCurrentUser() {
        if (auth.currentUser !== null) {
            setCurrentUser(auth.currentUser);
            getUserName(auth.currentUser.uid);

        }
    }
    
    async function getUserName(uid) {

        const errorMessage = document.getElementsByClassName('errorMessage')[0];

       try {
           let getUserNameFromFireBase = [];

           const q = query(collection(db, "Users"), where("userId", "==", uid));

           const querySnapshot = await getDocs(q);
           querySnapshot.forEach((doc) => {
               // doc.data() is never undefined for query doc snapshots
               getUserNameFromFireBase.push({ ...doc.data() });
           });
           if (getUserNameFromFireBase.length >= 1) {
               setUserName(getUserNameFromFireBase[0].userName);
           }
       } catch (error) {
            errorMessage.innerHTML = "Something went wrong while getting the user";   
       }
    }

    function showPasswordFields() {
       const psBox = document.getElementsByClassName('passwordChangeBox')[0];
        const changePasswordLink = document.getElementsByClassName('changePasswordLink')[0];
        const cancelBtn = document.getElementsByClassName('btnCancel')[0];
       if (psBox.style.display === "none") {
           psBox.style.display = "flex";
           cancelBtn.style.display = "block";
           changePasswordLink.style.display = "none";
       }else{
              psBox.style.display = "none";
            changePasswordLink.style.display = "block";
           cancelBtn.style.display = "none";
       }
    }

    function changePassword(user, newPassword){

        document.getElementsByClassName('pasChangeInfo')[0].innerHTML = "";

        try {
            updatePassword(user, newPassword).then(() => {
                document.getElementsByClassName('pasChangeInfo')[0].style.color = 'green';
                document.getElementsByClassName('pasChangeInfo')[0].innerHTML = "Password changed successfully.";
            }).catch((error) => {
                document.getElementsByClassName('pasChangeInfo')[0].style.color = 'red';
                if (error.code === "auth/requires-recent-login") {
                    document.getElementsByClassName('pasChangeInfo')[0].innerHTML = "Please sign in again to change password.";

                }
                else {
                    document.getElementsByClassName('pasChangeInfo')[0].innerHTML = "Password not changed: " + error.message + " Please try again.";
                }
            });
            showPasswordFields();
        } catch (error) {
            document.getElementsByClassName('errorMessage')[0].innerHTML = "Something went wrong while changing password:" + error;
        }
    }
};

export default Account;